export type BackSideMeishiList = {
  color: Meishi[];
  monochrome: Meishi[];
};

export type Meishi = {
  designNo: number;
  color: "color" | "monochrome";
};

export const mapMeishi = (meishi: Meishi): Meishi => {
  return {
    designNo: +meishi.designNo,
    color: meishi.color
  };
};

export type Paper = {
  paperNo: string;
  name: string;
  thickness: string;
  isChargeFlag: "0" | "1";
  oneSideFlag: "0" | "1";
};

export type VacationInformation = {
  vacation: string;
};

export type LogoFile = {
  filename: string;
  original: string;
};
